// extracted by mini-css-extract-plugin
module.exports = {"topHeader":"Header_topHeader__AVvIi","bottomHeader":"Header_bottomHeader__1EaUO"};